import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { canAccessPlatformHub, defaultPlatformPath } from "@/navigation/platform-access";
import { routes } from "./all_routes";

export function SuiteHomeRedirect() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="suite-center-message">
        <p className="text-muted mb-0">Chargement…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }

  if (canAccessPlatformHub(user) && user?.isSuperAdmin) {
    return <Navigate to={defaultPlatformPath(user)} replace />;
  }

  return <Navigate to={routes.modules} replace />;
}
